import { render, staticRenderFns } from "./DangerGovern.vue?vue&type=template&id=009f3962&scoped=true"
import script from "./DangerGovern.vue?vue&type=script&lang=js"
export * from "./DangerGovern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f3962",
  null
  
)

export default component.exports